import React from 'react';
import styled from 'styled-components';


const ProdSliderImgBlock = styled.div``;

const BackBlock = styled.div`
    position: absolute;
    top: 0;
    width: 120px;
    height: 120px;
    -webkit-transition: opacity 0.3s;
    -o-transition: opacity 0.3s;
    transition: opacity 0.3s;
    overflow: hidden;
    opacity: 0;
`
const BackTextBlock = styled.div`
    background-color: rgba(0,0,0,.5);
    display: block;
    height: 120px;
    border-radius: 4px;
`;

const BackTextSpanBlock = styled.span`
    color: #fff;
    display: block;
    font-size: 14px;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    width: 100%;
    padding: 0 5px;
`;

const FrontBlock = styled.div`
    width: 120px;
    height: 100%;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    margin: 0 10px;
    display: block;
    float: left;
    height: 100%;
    min-height: 1px;

    &:hover .BackBlockClass {
        opacity: 1;
    }
`;

const FrontImgBlock = styled.img`
    vertical-align: bottom;
    opacity: 1;
    width: 120px;
    background-image:url(${props => props.src});
    background-position: center;
    background-repeat: no-repeat;
    border: none;
`

const ProdSliderImg = ({ img, text }) => {

    if (img === null) {
        return <ProdSliderImgBlock />;
    }

    return (
        <ProdSliderImgBlock>
            <FrontBlock>
                <FrontImgBlock src={img} />
                <BackBlock className="BackBlockClass">
                    <BackTextBlock>
                        <BackTextSpanBlock>{text}</BackTextSpanBlock>
                    </BackTextBlock>
                </BackBlock>
            </FrontBlock>


        </ProdSliderImgBlock>
    );
};

export default ProdSliderImg;